var map = {
	"./en-sg": 16505,
	"./en-sg.js": 16505,
	"./es": 86640,
	"./es-us": 36430,
	"./es-us.js": 36430,
	"./es.js": 86640,
	"./eu": 32711,
	"./eu.js": 32711,
	"./ja": 46176,
	"./ja.js": 46176,
	"./zh-cn": 62658,
	"./zh-cn.js": 62658,
	"node_modules/moment/locale/en-sg": 16505,
	"node_modules/moment/locale/en-sg.js": 16505,
	"node_modules/moment/locale/es": 86640,
	"node_modules/moment/locale/es-us": 36430,
	"node_modules/moment/locale/es-us.js": 36430,
	"node_modules/moment/locale/es.js": 86640,
	"node_modules/moment/locale/eu": 32711,
	"node_modules/moment/locale/eu.js": 32711,
	"node_modules/moment/locale/ja": 46176,
	"node_modules/moment/locale/ja.js": 46176,
	"node_modules/moment/locale/zh-cn": 62658,
	"node_modules/moment/locale/zh-cn.js": 62658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22373;